// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Mb5o","inputDescription":"styles_inputDescription__ykKwy"};